import React from 'react'
import { slugs } from '@/constants/slugs'
import {
  YoungWashingtonDetailsContent,
  SketchDetailsContent,
  SeniorDetailsContent,
  TruthAndTreasonDetailsContent,
  DavidDetailsContent,
  IwasDetailsContent,
} from '@/views/PreSales/PreSalesGiveawayView/config/giveaway-details-content/projects'

const DETAILS_CONFIGS: Record<string, React.ComponentType> = {
  [slugs.sketch]: SketchDetailsContent,
  [slugs.youngWashington]: YoungWashingtonDetailsContent,
  [slugs.senior]: SeniorDetailsContent,
  [slugs.truthAndTreason]: TruthAndTreasonDetailsContent,
  [slugs.david]: DavidDetailsContent,
  [slugs.iWasAStranger]: IwasDetailsContent,
}

export const getGiveawayDetailsContent = (theatricalSlug: string): JSX.Element | null => {
  const Component = DETAILS_CONFIGS[theatricalSlug]
  return Component ? <Component /> : null
}
